import { render, staticRenderFns } from "./ArticlesDetail.vue?vue&type=template&id=c3e4e4b6"
import script from "./ArticlesDetail.vue?vue&type=script&lang=js"
export * from "./ArticlesDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticlesDetail.vue?vue&type=style&index=0&id=c3e4e4b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports